import React from "react";
import { useNavigate } from "react-router-dom";

function AccessDenied({ type }) {
  const navigate = useNavigate();

  return (
    <div className="bg-white h-screen flex justify-center items-center">
      <div className="h-[65%] w-1/2 text-center space-y-4 flex-col items-center relative">
        <div className="py-2">
          <h1 className="text-[--bg-color-500] font-extrabold text-9xl font-inter leading-[25px] tracking-tight">
            Oops!
          </h1>
        </div>
        <div className="py-8">
          <h4 className="text-[--bg-color-500] text-2xl font-semibold py-4">
            {type === "404" ? "404 – Page Not Found" : "No Access"}
          </h4>
        </div>
        <div className="flex justify-center">
          <div className={`${type === "404" ? "w-3/4" : "w-full"}`}>
            <p className="text-[#202E56] text-xl font-medium leading-[25px] tracking-tight font-inter">
              {type === "404"
                ? "The page you are looking for might have been removed,"
                : "You do not have access to the page you are looking for."}
            </p>
            <p
              className={`text-[#202E56] text-xl font-medium leading-[25px] tracking-tight mt-[-5px] font-inter`}
            >
              {type === "404"
                ? "had its name changed or is temporarily unavailable."
                : "Please contact your admin or the Shiperone Workflows support team."}
            </p>
          </div>
        </div>
        <div className="flex justify-center absolute bottom-10 w-full">
          <div
            className="w-1/4 bg-[--bg-color-500] text-white p-2 text-xl font-inter leading-[25px] hover:bg-[--bg-color-700] border rounded-full cursor-pointer"
            onClick={() => (type === "404" ? navigate(-1) : navigate(-2))}
          >
            Back
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccessDenied;
